import React, { useEffect, useState } from 'react';
import { getUserActivityHistoryFromAlcohol } from '../../../services/apis/alcohol/user';

const formatDate = value => {
    if (!value) return '—';
    const text = String(value);
    return /^\d{14}$/.test(text)
        ? `${text.slice(0, 4)}-${text.slice(4, 6)}-${text.slice(6, 8)} ${text.slice(8, 10)}:${text.slice(10, 12)}:${text.slice(12, 14)}`
        : text;
};

const initialPeriod = () => {
    const today = new Date();
    const month = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}`;
    return { start: `${month}-01`, end: `${month}-${String(today.getDate()).padStart(2, '0')}` };
};

function AlcoholMyPageActivityHistory() {
    const [inputDate, setInputDate] = useState(initialPeriod);
    const [query, setQuery] = useState(() => ({ ...initialPeriod(), page: 1 }));
    const [history, setHistory] = useState([]);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [dateError, setDateError] = useState('');

    useEffect(() => {
        let active = true;
        setLoading(true);
        setError('');
        setHistory([]);
        setTotal(0);
        getUserActivityHistoryFromAlcohol({
            start: query.start.replace(/-/g, ''),
            end: query.end.replace(/-/g, ''),
            page: query.page,
        }).then(res => {
            if (!active) return;
            if (!(res?.status >= 200 && res.status < 300) || !Array.isArray(res.data)) {
                throw new Error('history unavailable');
            }
            setHistory(res.data);
            const count = Number(res.data[0]?.totalCnt);
            setTotal(Number.isFinite(count) && count >= 0 ? count : res.data.length);
        }).catch(() => {
            if (active) setError('활동 기록을 불러오지 못했습니다. 잠시 후 다시 조회해주세요.');
        }).finally(() => {
            if (active) setLoading(false);
        });
        return () => { active = false; };
    }, [query]);

    const search = event => {
        event.preventDefault();
        if (!inputDate.start || !inputDate.end || inputDate.start > inputDate.end) {
            setDateError('시작일과 종료일을 올바르게 선택해주세요.');
            return;
        }
        setDateError('');
        setQuery({ ...inputDate, page: 1 });
    };
    const pages = Math.max(1, Math.ceil(total / 10));
    let emptyMessage = '선택한 기간의 활동 기록이 없습니다.';
    if (error) emptyMessage = '조회에 실패했습니다.';
    if (loading) emptyMessage = '활동 기록을 불러오는 중입니다.';

    return (
        <div className="dashboardContent">
            <div className="dashboardContent__title">
                <span className="dashboardContent__title__content">마이페이지 {'>'} 활동 기록</span>
            </div>
            <div className="mypage_login_history_wrapper mypage_activity_history">
                <h1 className="title">내 활동 기록 보기</h1>
                <p className="description">로그인 및 서비스 이용 기록을 기간별로 조회할 수 있습니다.</p>
                <div className="table_wrapper" aria-busy={loading}>
                    <form className="table_search_row" onSubmit={search}>
                        <input type="date" aria-label="시작일" value={inputDate.start}
                            onChange={e => setInputDate({ ...inputDate, start: e.target.value })} />
                        <span className="date_bar">ㅡ</span>
                        <input type="date" aria-label="종료일" value={inputDate.end}
                            onChange={e => setInputDate({ ...inputDate, end: e.target.value })} />
                        <button className="message_search_button" type="submit" disabled={loading}>조회</button>
                    </form>
                    {dateError && <p role="alert" className="history_error">{dateError}</p>}
                    {error && <p role="alert" className="history_error">{error}</p>}
                    <div className="history_table_scroll">
                        <table className="AlcoholCommonTable" aria-label="활동 기록">
                            <thead><tr>{['일시', '사용자 UID', '작업 코드', '작업 상세', '접속 IP'].map(label => <th key={label}>{label}</th>)}</tr></thead>
                            <tbody>
                                {history.map((item, index) => (
                                    <tr key={item.id ?? `${item.uid}-${item.insDate}-${index}`}>
                                        <td>{formatDate(item.insDate || item.actDate)}</td>
                                        <td>{item.uid || '—'}</td>
                                        <td>{item.fncCode || '—'}</td><td>{item.act || '—'}</td><td>{item.ip || '—'}</td>
                                    </tr>
                                ))}
                                {!history.length && <tr><td colSpan={5}>
                                    <span role="status">{emptyMessage}</span>
                                </td></tr>}
                            </tbody>
                        </table>
                    </div>
                    {!loading && !error && total > 0 && <nav className="history_pagination" aria-label="활동 기록 페이지">
                        <button type="button" disabled={query.page <= 1} onClick={() => setQuery({ ...query, page: query.page - 1 })}>이전</button>
                        <span>{query.page} / {pages} 페이지 · 총 {total}건</span>
                        <button type="button" disabled={query.page >= pages} onClick={() => setQuery({ ...query, page: query.page + 1 })}>다음</button>
                    </nav>}
                </div>
            </div>
        </div>
    );
}

export default AlcoholMyPageActivityHistory;
